// src/theme/themeManager.js

const ABOUT_KEY = "seen_about_v1";
const THEME_KEY = "theme_pref_v1"; // "day" | "night"

export function hasSeenAbout() {
  try {
    return localStorage.getItem(ABOUT_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSeenAbout() {
  try {
    localStorage.setItem(ABOUT_KEY, "1");
  } catch {}
}

export function getThemePref() {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === "day" || v === "night" ? v : null;
  } catch {
    return null;
  }
}

export function setThemePref(mode) {
  try {
    if (mode === "day" || mode === "night") {
      localStorage.setItem(THEME_KEY, mode);
    }
  } catch {}
}
